import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-trajectoryQuery",
  "use": "icon-trajectoryQuery-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-trajectoryQuery\">\n  <path d=\"M6.5 18.5c-1.7 0-3-1.2-3-2.8s1.3-2.8 3-2.8h11c1.7 0 3-1.2 3-2.8s-1.3-2.8-3-2.8H14\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" />\n  <path d=\"M6.5 20.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM14 7.3 10.7 4 14 1.7\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol